import http from './http'

export default {
    /**
     * Create a new application.
     * @param {Object} payload 
     * @returns {Promise}
     */
    create(payload) {
        return http.post('application/full', payload)
            .then(response => response.data)
    }
}